import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Slot} from '../models/slot';
import {Observable} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class SlotService {

  private itemDoc: AngularFirestoreDocument<Slot>;
  private item: Observable<Slot>;

  public slotDataSource: MatTableDataSource<any>;

  constructor (private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions) { }

  select () {
    return this.db.collection<Slot>('sbccv_event_slots', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  loadSlots (event_id) {

    return this.db.collection<Slot>('sbccv_event_slots', ref => ref
      .where("event_id", "==", event_id)
      .orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        let array: Slot[] = []
        result.forEach((item) => {

          if (!item.payload.doc.data().topic_id) {

            let entity: Slot = new Slot()
            entity.id = item.payload.doc.id
            entity.name = item.payload.doc.data().name
            entity.event_id = item.payload.doc.data().event_id
            entity.event_name = item.payload.doc.data().event_name
            entity.slot_quantity = item.payload.doc.data().slot_quantity
            entity.slot_used = item.payload.doc.data().slot_used
            entity.slot_wait = item.payload.doc.data().slot_wait
            entity.slot_wait_used = item.payload.doc.data().slot_wait_used
            entity.categories = item.payload.doc.data().categories

            array.push(entity)
          }


        })

        this.slotDataSource = new MatTableDataSource(array);

      })
  }

  loadTopicSlots (event_id, topic_id) {

    return this.db.collection<Slot>('sbccv_event_slots', ref => ref
      .where("event_id", "==", event_id)
      .where("topic_id", "==", topic_id)
      .orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        let array: Slot[] = []
        result.forEach((item) => {

          if (item.payload.doc.data().topic_id) {
            let entity: Slot = new Slot()
            entity.id = item.payload.doc.id
            entity.name = item.payload.doc.data().name
            entity.event_id = item.payload.doc.data().event_id
            entity.event_name = item.payload.doc.data().event_name
            entity.slot_quantity = item.payload.doc.data().slot_quantity
            entity.slot_used = item.payload.doc.data().slot_used
            entity.slot_wait = item.payload.doc.data().slot_wait
            entity.slot_wait_used = item.payload.doc.data().slot_wait_used

            entity.topic_id = item.payload.doc.data().topic_id
            entity.topic_name = item.payload.doc.data().topic_name

            entity.categories = item.payload.doc.data().categories

            array.push(entity)
          }

        })

        this.slotDataSource = new MatTableDataSource(array);

      })
  }

  selectById (id) {
    this.itemDoc = this.db.doc<Slot>('sbccv_event_slots/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert (entity: Slot) {
    delete entity.id;
    return this.db.collection('sbccv_event_slots').add(Object.assign({}, entity));
  }

  update (entity: Slot) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_event_slots').doc(id).set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_event_slots').doc(entity_id).delete();
  }

  updateCategory (id: any, categories: any) {
    return this.db.collection('sbccv_event_slots').doc(id).set(Object.assign({}, {'categories': categories}), {'merge': true});
  }

  selectByEvent (event_id) {
    return this.db.collection<Slot>('sbccv_event_slots', ref => ref
      .where('event_id', '==', event_id)
      .orderBy('name', 'asc'))
      .get();
  }

  async checkSlotsAvailable (product_id) {
    const checkPromise = new Promise(async (resolve, reject) => {

      const checkResult: any[] = []
      return this.db.collection<any>('sbccv_product_itens', ref => ref
        .where('product_id', '==', product_id))
        .get()
        .subscribe(async (resultItem) => {
          resultItem.forEach(async (item) => {

            const event_id = item.data().event_id
            //console.log('event_id: ' + event_id)

            return this.db.collection<any>('sbccv_event_slots', ref => ref
              .where('event_id', '==', event_id))
              .get()
              .subscribe(async (resultSlot) => {
                resultSlot.forEach(async (item) => {
                  //console.log('slot: ' + JSON.stringify(item.data()))
                  const slot_quantity: number = Number(item.data().slot_quantity)
                  const slot_used: number = Number(item.data().slot_used)
                  
                  // console.log("sbccv_event_slots: " + item.id)

                  checkResult.push({
                    'event_id': event_id,
                    'slot_quantity': item.data().slot_quantity,
                    'slot_used': item.data().slot_used,
                    'slot_wait': item.data().slot_wait,
                    'slot_wait_used': item.data().slot_wait_used,
                    'check': slot_quantity > slot_used
                  })

                  resolve(checkResult)
                })
              })


          })
        })

    })
    return Promise.all([ checkPromise ])
  }

  updateSlotQtd (product_id: string, topic_id: string, upDown: boolean) { //true = +, false = -

    /*
    console.log("updateSlotQtd product_id: " + product_id)
    console.log("updateSlotQtd topic_id: " + topic_id)
    console.log("updateSlotQtd upDown: " + upDown)
    */

    return this.db.collection<any>('sbccv_product_itens', ref => ref
      .where('product_id', '==', product_id))
      .get()
      .subscribe(async (resultItem) => {

        resultItem.forEach((item) => {
          const event_id = item.data().event_id

          if (topic_id) {
            // console.log("updateSlotQtd topic_id: " + topic_id)

            return this.db.collection<any>('sbccv_event_slots', ref => ref
              .where('event_id', '==', event_id)
              .where('topic_id', '==', topic_id)
              .limit(1))
              .get()
              .subscribe((resultSlot) => {
                const slot_id = resultSlot.docs[ 0 ].id
                const slot_data = resultSlot.docs[ 0 ].data()
                this.updateSlot(slot_id, slot_data, upDown)
              })
          } else {
            // console.log("updateSlotQtd event_id: " + event_id)

            return this.db.collection<any>('sbccv_event_slots', ref => ref
              .where('event_id', '==', event_id)
              .limit(1))
              .get()
              .subscribe((resultSlot) => {
                const slot_id = resultSlot.docs[ 0 ].id
                const slot_data = resultSlot.docs[ 0 ].data()

                this.updateSlot(slot_id, slot_data, upDown)
              })
          }
        })
      })

  }

  updateSlot (slot_id, slot_data, upDown) {

    // console.log("slot_id: " + slot_id)
    // console.log("slot_data: " + JSON.stringify(slot_data))

    const slot_used: number = Number(slot_data.slot_used)
    let slot_used_update: number = 0
    if (upDown)
      slot_used_update = slot_used + 1
    else
      slot_used_update = slot_used - 1

    const slot_quantity: number = Number(slot_data.slot_quantity)

    /*
    console.log('slot_id:' + slot_id)
    console.log('slot_quantity: ' + slot_quantity)
    console.log('slot_used: ' + slot_used)
    console.log('slot_update: ' + slot_used_update)
    */
   
    this.db.collection<any>('sbccv_event_slots')
      .doc(slot_id)
      .update({'slot_used': slot_used_update})
      .then(() => {
        console.log("slot updated")
      })
      .catch(() => {
        console.log("ERROR: slot updated")
      })

  }

  makeMsgError (errorsCode) {
    /*
    let msgError: string
        switch (errorsCode) {
          case "":
            msgError = ""
            break;
        }
        return msgError
    */
    return errorsCode
  }

}


